import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class TitleService extends BehaviorSubject<string> {
	constructor() {
		super('');
	}

}
